import React from "react"
import Composer from "react-composer"
import { PureComponent } from "react"
import { withRouter } from "next/router"
import "./idea-details.scss"
import Tag from "../../components/tag/tag"
import { Mutation, Query } from "react-apollo"
import Cta from "../../components/cta/cta"
import AddUser from "../../components/add-user/add-user"
import gql from "graphql-tag"
import { getDaysAgo } from "../../utils/date"
import "emoji-mart/css/emoji-mart.css"
import { Picker } from "emoji-mart"
import { LOCAL_TOGGLE_IDEA_USER_DETAILS } from "../../apollo-state/graphql/mutations"
import FormErrorMessage from "../../components/form-error-message/form-error-message"
import { withSnackbar } from "react-simple-snackbar"
import { snackbarOptions } from "../../config"
import ReactMarkdown from "react-markdown"
import customRendererLink from "../../utils/custom-link-renderer"
import convertProfilePicUrl from "../../utils/convert-profile-pic-url"
import { JoinCard } from "../founder-page/sections"
import "../founder-page/founder-page.scss"

// signed-out visitors see the title and who posted it, the rest blurred
const lockedProps = (locked) =>
  locked ? { className: "idea-locked", "aria-hidden": true, inert: "" } : {}

// the API sends signed-out visitors no comments (backend
// ideaCommentsByIdeaId), so the blur covers blank rows instead
const LockedComments = () =>
  [90, 70, 80].map((width, i) => (
    <div className="comment idea-skeleton-row" key={i}>
      <span className="idea-skeleton idea-skeleton--avatar" />
      <span className="idea-skeleton" style={{ width: `${width}%` }} />
    </div>
  ))

export const SAVE_IDEA = gql`
  mutation TOGGLE_LIKE_IDEA($ideaId: ID!) {
    toggleSaveIdea(ideaId: $ideaId) {
      id
      totalLikes
      saves {
        id
        user {
          id
        }
      }
    }
  }
`

const UPDATE_IDEAS_LIKES = gql`
  mutation TOGGLE_LIKE_IDEA($ideaId: ID!) {
    toggleLikeIdea(ideaId: $ideaId) {
      id
      __typename
      totalLikes
      likes {
        id
        user {
          id
        }
      }
    }
  }
`

const ADD_IDEA_COMMENT = gql`
  mutation IDEA_COMMENT($ideaId: ID!, $body: String!, $parentId: ID) {
    addIdeaComment(ideaId: $ideaId, body: $body, parentId: $parentId) {
      id
      body
      createdBy {
        firstName
      }
    }
  }
`
const IDEA_COMMENTS = gql`
  query ideascomment($ideaId: ID!) {
    ideaCommentsByIdeaId(ideaId: $ideaId) {
      id
      body
      createdAt
      totalLikes
      likes {
        id
        user {
          id
        }
      }
      createdBy {
        profilePic
        firstName
        id
      }
      parent {
        id
      }
      replies {
        id
        body
        createdAt
        totalLikes
        likes {
          id
          user {
            id
          }
        }
        createdBy {
          profilePic
          firstName
          id
        }
      }
    }
  }
`

const TOGGLE_COMMENT_LIKES = gql`
  mutation TOGGLE_COMMENT_LIKES($commentId: ID!) {
    toggleCommentLikes(commentId: $commentId) {
      id
      totalLikes
      likes {
        id
        user {
          id
        }
      }
      replies {
        id
        totalLikes
        likes {
          id
          user {
            id
          }
        }
      }
    }
  }
`
class IdeasDetails extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      user: {},
      commentsFieldId: "",
      replyComment: "",
      showFieldId: "",
      comments: "",
      isEmojiShowComment: false,
      isEmojiShowReplay: false,
      isCommentValid: true,
      isReplayValid: true,
    }
  }

  componentDidMount() {
    const { data } = this.props
    if (data && data.id) {
      this.setState((p) => ({ ...p, user: data }))
    }
  }
  showReplyField = (id) => {
    this.setState((prev) => ({
      ...prev,
      showFieldId: prev.showFieldId === id ? "" : id,
    }))
  }
  setAddedStateData = (userId) => {
    this.setState((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        createdBy: {
          ...prev.user.createdBy,
          addedBy:
            prev.user?.createdBy?.id === userId &&
            prev.user.createdBy.addedBy &&
            prev.user.createdBy.addedBy.length
              ? []
              : [userId],
        },
      },
    }))
  }
  setSaveStateData = (userId) => {
    this.setState((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        saves:
          prev.user.saves && prev.user.saves.length > 0
            ? []
            : [{ user: { id: userId } }],
      },
    }))
  }
  navigateToProfile = (userId) => {
    this.props.router.push(`/profile/${userId}`)
  }
  render() {
    const { me } = this.props
    const { user } = this.state
    const { openSnackbar } = this.props
    console.log(this.props)
    return (
      <Composer
        components={[
          ({ render }) => (
            <Query
              query={IDEA_COMMENTS}
              skip={!this.state.user?.id}
              variables={{
                ideaId: this.state?.user?.id,
              }}
            >
              {render}
            </Query>
          ),
          ({ render }) => (
            <Mutation
              mutation={ADD_IDEA_COMMENT}
              refetchQueries={[
                {
                  query: IDEA_COMMENTS,
                  variables: { ideaId: this.state?.user?.id },
                },
              ]}
              onCompleted={() => {
                openSnackbar("Comment added successfully")
                this.setState({
                  commentsFieldId: "",
                  comments: "",
                  replyComment: "",
                  showFieldId: "",
                  isEmojiShowComment: false,
                  isEmojiShowReplay: false,
                  isCommentValid: true,
                  isReplayValid: true,
                })
              }}
            >
              {render}
            </Mutation>
          ),
        ]}
      >
        {([
          { data: { ideaCommentsByIdeaId: comments } = {} },
          addIdeaComment,
        ]) => {
          return (
            <main className="ideaspagemain">
              <div className="idea-post">
                <div className="idea-post__header">
                  <div className="idea-post__icon">
                    <img
                      src={convertProfilePicUrl(user?.createdBy?.profilePic, 60, 60)}
                      alt="user"
                      width={60}
                      height={60}
                      style={{ borderRadius: "50%", objectFit: "cover" }}
                    />
                  </div>
                  <div className="idea-post__title-section">
                    <h1 className="idea-post__title">{user?.title}</h1>
                    <div className="idea-post__meta">
                      <span className="idea-post__creator">
                        Created by {user?.createdBy?.firstName || "Anonymous"}
                      </span>
                    </div>
                    <div className="idea-post__tags">
                      {user.ideaIndustry && (
                        <Tag
                          title={user.ideaIndustry?.label}
                          className="idea-tag industry-tag"
                          key={user.ideaIndustry?.popUpData?.id}
                          label={user.ideaIndustry?.label}
                        />
                      )}
                      {user.ideaStage && (
                        <Tag
                          title={user.ideaStage?.label}
                          className="idea-tag stage-tag"
                          key={user.ideaStage?.popUpData?.id}
                          label={user.ideaStage?.label}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {!me?.id && (
                  <div className="idea-post__join">
                    <JoinCard user={user?.createdBy || {}} />
                  </div>
                )}

                <div {...lockedProps(!me?.id)}>
                <div className="idea-post__content">
                  <div className="idea-post__elevator-pitch">
                    <ReactMarkdown
                      source={user?.elevatorPitch}
                      escapeHtml={false}
                      renderers={customRendererLink}
                    />
                  </div>
                </div>

                <div className="idea-post__footer">
                  <div className="idea-post__stats">
                    <Mutation
                      mutation={UPDATE_IDEAS_LIKES}
                      onCompleted={(data) => {
                        // Update local state with the response from the server
                        this.setState(prev => ({
                          ...prev,
                          user: {
                            ...prev.user,
                            totalLikes: data.toggleLikeIdea.totalLikes,
                            likes: data.toggleLikeIdea.likes,
                          }
                        }))
                      }}
                    >
                      {(toggleLikeIdea) => (
                        <button
                          className={`idea-card__action-button ${
                            user?.likes?.find((e) => e?.user?.id === me?.id)?.id
                              ? "liked"
                              : ""
                          }`}
                          onClick={() => {
                            if (me?.id) {
                              toggleLikeIdea({
                                variables: {
                                  ideaId: user?.id,
                                },
                              })
                            }
                          }}
                        >
                          <img
                            src={`${
                              user?.likes?.find((e) => e?.user?.id === me?.id)?.id
                                ? "/static/icons/heart-red.svg"
                                : "/static/icons/hard.svg"
                            }`}
                            width={18}
                            height={18}
                            alt="Like"
                          />
                          <span>{user?.totalLikes || 0} likes</span>
                        </button>
                      )}
                    </Mutation>
                    
                    {me?.id && (
                      <Mutation
                        mutation={SAVE_IDEA}
                        onCompleted={() =>
                          this.setSaveStateData(me?.id)
                        }
                      >
                        {(toggleSaveIdea) => (
                          <button
                            className={`idea-card__action-button save-button ${
                              user?.saves?.find((e) => e?.user?.id === me?.id || e === me?.id)
                                ? "saved"
                                : ""
                            }`}
                            onClick={() =>
                              toggleSaveIdea({
                                variables: {
                                  ideaId: user.id,
                                },
                              })
                            }
                          >
                            <img 
                              src="/static/icons/bookmark.svg" 
                              alt="Save"
                              width={14}
                              height={14}
                            />
                            <span>Save</span>
                          </button>
                        )}
                      </Mutation>
                    )}

                    <div className="idea-card__stat">
                      <img
                        src="/static/icons/message-dark.svg"
                        width={18}
                        height={18}
                        alt="Comments"
                      />
                      <span>{user?.totalComments || 0} comments</span>
                    </div>
                  </div>

                  <div className="idea-post__actions">
                    {me?.id && (
                      <Mutation mutation={LOCAL_TOGGLE_IDEA_USER_DETAILS}>
                        {(toggleIdeaPopup) => (
                          <button
                            className="idea-card__action-button view-button"
                            onClick={toggleIdeaPopup}
                          >
                            <img
                              src="/static/icons/chevron-down.svg"
                              alt="View"
                              width={16}
                              height={16}
                            />
                            Contact {user?.createdBy?.firstName}
                          </button>
                        )}
                      </Mutation>
                    )}
                  </div>
                </div>
                </div>
              </div>
              <div {...lockedProps(!me?.id)}>
              <div className="comments-container">
                <h3>Comments</h3>
                <hr />
                {!me?.id && <LockedComments />}
                {Boolean(comments?.length) &&
                  comments.map((comment) => (
                    <React.Fragment key={comment.id}>
                      <div className="comment">
                        <img
                          className="avatar"
                          src={comment.createdBy?.profilePic}
                          alt={"image"}
                          width={53}
                          height={53}
                          style={{ cursor: "pointer", borderRadius: "50%" }}
                          onClick={() => this.navigateToProfile(comment.createdBy?.id)}
                        />{" "}
                        <div className="content">
                          <span
                            className="name"
                            style={{ cursor: "pointer", color: "#0066cc" }}
                            onClick={() => this.navigateToProfile(comment.createdBy?.id)}
                          >
                            {comment?.createdBy?.firstName}
                          </span>
                          <p>{comment?.body}</p>
                          <div className="meta">
                            <div className="meta">
                              {getDaysAgo(comment.createdAt)} ·{" "}
                              {me?.id && (
                                <span
                                  className="reply"
                                  onClick={() =>
                                    this.showReplyField(comment.id)
                                  }
                                >
                                  Reply
                                </span>
                              )}
                            </div>
                            {this.state.showFieldId === comment.id && (
                              <>
                                <div className="comment-box">
                                  <div style={{ position: "relative" }}>
                                    <span
                                      onClick={() =>
                                        this.setState({
                                          isEmojiShowReplay:
                                            !this.state.isEmojiShowReplay,
                                        })
                                      }
                                      className="emoji-icon"
                                    >
                                      😊
                                    </span>
                                    <Picker
                                      style={{
                                        position: "absolute",
                                        zIndex: 1000,
                                        display: this.state.isEmojiShowReplay
                                          ? "block"
                                          : "none",
                                      }}
                                      set="apple"
                                      onSelect={(emoji) =>
                                        this.setState({
                                          replyComment:
                                            this.state.replyComment +
                                            emoji.native,
                                        })
                                      }
                                    />
                                  </div>
                                  <input
                                    type="text"
                                    value={this.state.replyComment}
                                    onChange={(e) =>
                                      this.setState({
                                        replyComment: e.target.value,
                                        commentsFieldId: user?.id,
                                      })
                                    }
                                    placeholder="Add a comment..."
                                    className="comment-input"
                                  />
                                  <button
                                    onClick={() => {
                                      if (this.state.replyComment.length > 0) {
                                        addIdeaComment({
                                          variables: {
                                            ideaId: user?.id,
                                            body: this.state.replyComment,
                                            parentId: comment.id,
                                          },
                                        })
                                        this.setState({
                                          isReplayValid: true,
                                          isCommentValid: true,
                                        })
                                      } else {
                                        this.setState({
                                          isReplayValid: false,
                                          isCommentValid: true,
                                        })
                                      }
                                    }}
                                    className="post-btn"
                                  >
                                    Post
                                  </button>
                                </div>
                                <div style={{ marginTop: "10px" }}>
                                  <FormErrorMessage
                                    isValid={this.state.isReplayValid}
                                    validationErrorMsg={"Please add a comment!"}
                                    noChevron
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="likes">
                          <Mutation mutation={TOGGLE_COMMENT_LIKES}>
                            {(toggleCommentLikes) => (
                              <span className="likes">
                                <img
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    if (me?.id) {
                                      toggleCommentLikes({
                                        variables: {
                                          commentId: comment.id,
                                          userId: me?.id,
                                        },
                                      })
                                    }
                                  }}
                                  src={`${
                                    comment?.likes?.find(
                                      (e) => e?.user?.id === me?.id
                                    )?.id
                                      ? "/static/icons/heart-red.svg"
                                      : "/static/icons/hard.svg"
                                  }`}
                                  width={20}
                                  height={20}
                                />{" "}
                                {comment?.totalLikes || 0}
                              </span>
                            )}
                          </Mutation>
                        </div>
                      </div>
                      {Boolean(comment.replies.length) &&
                        comment.replies.map((reply) => (
                          <div key={reply.id} className="comment reply">
                            <img
                              className="avatar"
                              src={reply.createdBy?.profilePic}
                              alt={"image"}
                              width={50}
                              height={50}
                              style={{ cursor: "pointer", borderRadius: "50%" }}
                              onClick={() => this.navigateToProfile(reply.createdBy?.id)}
                            />
                            <div className="content">
                              <span 
                                className="name"
                                style={{ cursor: "pointer", color: "#0066cc" }}
                                onClick={() => this.navigateToProfile(reply.createdBy?.id)}
                              >
                                {reply?.createdBy?.firstName}
                              </span>
                              <p>{reply?.body}</p>
                              <div className="meta">
                                {getDaysAgo(reply.createdAt)} ·{" "}
                              </div>
                            </div>
                            <div className="likes">
                              <Mutation mutation={TOGGLE_COMMENT_LIKES}>
                                {(toggleCommentLikes) => (
                                  <span className="likes">
                                    <img
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        if (me?.id) {
                                          toggleCommentLikes({
                                            variables: {
                                              commentId: reply.id,
                                            },
                                          })
                                        }
                                      }}
                                      src={`${
                                        reply?.likes?.find(
                                          (e) => e?.user?.id === me?.id
                                        )?.id
                                          ? "/static/icons/heart-red.svg"
                                          : "/static/icons/hard.svg"
                                      }`}
                                      width={20}
                                      height={20}
                                    />{" "}
                                    {reply?.totalLikes || 0}
                                  </span>
                                )}
                              </Mutation>
                            </div>
                          </div>
                        ))}
                    </React.Fragment>
                  ))}
                {me?.id && (
                  <div className="comment-box">
                    <div style={{ position: "relative" }}>
                      <span
                        onClick={() =>
                          this.setState({
                            isEmojiShowComment: !this.state.isEmojiShowComment,
                          })
                        }
                        className="emoji-icon"
                      >
                        😊
                      </span>
                      <Picker
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          display: this.state.isEmojiShowComment
                            ? "block"
                            : "none",
                        }}
                        set="apple"
                        onSelect={(emoji) =>
                          this.setState({
                            comments: this.state.comments + emoji.native,
                          })
                        }
                      />
                    </div>
                    <input
                      type="text"
                      placeholder="Add a comment..."
                      className="comment-input"
                      value={this.state.comments}
                      onChange={(e) =>
                        this.setState({
                          comments: e.target.value,
                          commentsFieldId: user?.id,
                        })
                      }
                    />
                    <button
                      onClick={() => {
                        if (this.state.comments.length > 0) {
                          this.setState({
                            isCommentValid: true,
                            isReplayValid: true,
                          })
                          addIdeaComment({
                            variables: {
                              ideaId: user?.id,
                              body: this.state.comments,
                            },
                          })
                        } else {
                          this.setState({
                            isCommentValid: false,
                            isReplayValid: true,
                          })
                        }
                      }}
                      className="post-btn"
                    >
                      Post
                    </button>
                  </div>
                )}
                <div style={{ marginTop: "10px" }}>
                  <FormErrorMessage
                    isValid={this.state.isCommentValid}
                    validationErrorMsg={"Please add a comment!"}
                    noChevron
                  />
                </div>
              </div>
              </div>
            </main>
          )
        }}
      </Composer>
    )
  }
}

export default withSnackbar(withRouter(IdeasDetails), snackbarOptions)
